// extracted by mini-css-extract-plugin
module.exports = {"form":"CheckoutFormPagamento_form__bWV7h","notes":"CheckoutFormPagamento_notes__GEr7E","rotation":"CheckoutFormPagamento_rotation__MaB3v"};